import { Login } from '@app/components/Login';

export default function LoginPage() {
  return <Login backgroundImage="https://images.unsplash.com/photo-1563920443079-783e5c786b83" />;
}
